module.exports = "<div class=\"text-center gw-carousel__slide\" ng-transclude ng-class=\"{'gw-carousel__slide_active' : active === true}\"></div>"